angular.module("app").filter("hasChild", [ 'userStorage',
    function (userStorage) {

        return function (input) {
            var permissions = userStorage.getUserData().permissions;
            if (permissions && (permissions.indexOf('viewSystemSettings') !== -1 || permissions.indexOf('viewAvailableSystemSettings') !== -1)) {
                return input
            }
            if (input && input.length) {
                var i = 0,
                    childes = [];
                while (input[i]) {
                    if (input[i].child) {
                        childes.push(input[i])
                    }
                    i++;
                }
                if (childes.length) {
                    return childes
                }
                return false
            }
            return false
        }
    }
]).filter("mobileHasChild", [ 'userStorage',
    function (userStorage) {

        return function (input) {
            var permissions = userStorage.getUserData().permissions;
            if (permissions && (permissions.indexOf('viewMobileSystemSettings') !== -1 || permissions.indexOf('viewMobileAvailableSystemSettings') !== -1)) {
                return input
            }
            if (input && input.length) {
                var i = 0,
                    childes = [];
                while (input[i]) {
                    if (input[i].child) {
                        childes.push(input[i])
                    }
                    i++;
                }
                if (childes.length) {
                    return childes
                }
                return false
            }
            return false
        }
    }
]).filter("onlyChildes", [
    function () {
        return function (input) {
            if (input && input.length) {
                var i = 0,
                    childes = [];
                while (input[i]) {
                    if (!input[i].child) {
                        childes.push(input[i])
                    }
                    i++;
                }
                if (childes.length) {
                    return childes
                }
                return false
            }
            return false
        }
    }
]).filter("filterForProviderGames", [
    function () {

        function getItemFromList (filterQuery, list) {
            for (var i = 0, length = list.length; i < length; i++) {
                switch (true) {
                    case filterQuery.isMobile && (!!Number(list[i].is_mobile) == filterQuery.isMobile):
                    case filterQuery.isDesktop && (!Number(list[i].is_mobile) == filterQuery.isDesktop):
                    case filterQuery.all:
                        return true
                }
            }
            return false;
        }

        return function (input, query) {
            var output = [];
            if (input && input.length) {
                for (var i = 0, iLength = input.length; i < iLength; i++) {
                    if (getItemFromList(query , input[i].games)) {
                        output.push(input[i])
                    }
                }
            }
            return output
        };
    }
]).filter("filterForProviderGame", [
    function () {

        return function (input, query) {
            var output = [];
            if (input && input.length) {
                for (var i = 0, iLength = input.length; i < iLength; i++) {

                    switch (true) {
                        case query.isMobile && (!!Number(input[i].is_mobile) == query.isMobile):
                        case query.isDesktop && (!Number(input[i].is_mobile) == query.isDesktop):
                        case query.all:
                            output.push(input[i]);
                            break;
                    }
                }
            }
            return output
        };
    }
]).filter("configSkinByConfigId", [
    function () {
        return function findConfig(input, configId, parentConfig) {
            if (input && input.length && configId) {
                var i = 0, openConfig;
                while (input[i]) {
                    if (input[i].config_id == configId) {
                        return !(input[i].child && input[i].child.length) && parentConfig ? parentConfig : input[i];
                    }

                    if (input[i].child && input[i].child.length) {
                        if (openConfig = findConfig(input[i].child, configId, input[i])) {
                            return openConfig;
                        }
                    }
                    i++;
                }
            }
            
            return false;
        }
    }
]);



